import { render, staticRenderFns } from "./DeviceForm.vue?vue&type=template&id=4ca4c051"
import script from "./DeviceForm.vue?vue&type=script&lang=ts"
export * from "./DeviceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports